// extracted by css-extract-rspack-plugin
export default {"warningWrap":"invite__warningWrap--Vn9Mm","modalBody":"invite__modalBody--qyllj Modal__body--EJ7yy"};